module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-night1.79da7ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-night1.png
// module id = mmmK
// module chunks = 0